import React from 'react';
import { Card, Space, Typography, Button, Input } from 'antd';
import RichTextEditor from './RichTextEditor';
import EmailRecipientSelector from './EmailRecipientSelector';
import { EmailRecipient, ContactInfo } from './types';

const { Text } = Typography;

interface EmailComposeFormProps {
  emailSubject: string;
  onEmailSubjectChange: (value: string) => void;
  emailBody: string;
  onEmailBodyChange: (value: string) => void;
  emailList: string[];
  emailContactInfo: ContactInfo[];
  selectedEmailRecipients: EmailRecipient[];
  emailInputValue: string;
  onEmailInputChange: (value: string) => void;
  onEmailRecipientsChange: (recipients: EmailRecipient[]) => void;
  // isEmailNotificationEnabled: (email: string) => boolean;
  onSend: () => void;
  sendingNotes: boolean;
  contactLoading: boolean;
  isSendEmail: boolean;
}

const EmailComposeForm: React.FC<EmailComposeFormProps> = ({
  emailSubject,
  onEmailSubjectChange,
  emailBody,
  onEmailBodyChange,
  emailList,
  emailContactInfo,
  selectedEmailRecipients,
  emailInputValue,
  onEmailInputChange,
  onEmailRecipientsChange,
  // isEmailNotificationEnabled,
  onSend,
  sendingNotes,
  contactLoading,
  isSendEmail,
}) => {
  return (
    <>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Card
          title={
            <span style={{ fontSize: '16px', fontWeight: '600', color: '#1890ff' }}>
              {selectedEmailRecipients.length > 0
                ? '📧 Compose Email'
                : '📧 Save a Note'}
            </span>
          }
          style={{
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            border: '1px solid #e8f4fd',
          }}
        >
          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <EmailRecipientSelector
              emailList={emailList}
              emailContactInfo={emailContactInfo}
              selectedEmailRecipients={selectedEmailRecipients}
              emailInputValue={emailInputValue}
              onInputChange={onEmailInputChange}
              onRecipientsChange={onEmailRecipientsChange}
              // isEmailNotificationEnabled={isEmailNotificationEnabled}
            />
            <div>
              <Text
                strong
                style={{ fontSize: '14px', marginBottom: '8px', display: 'block' }}
              >
                Subject *
              </Text>
              <Input
                placeholder="Enter email subject"
                value={emailSubject}
                onChange={(e) => onEmailSubjectChange(e.target.value)}
                style={{
                  height: '40px',
                  fontSize: '14px',
                  borderRadius: '6px',
                }}
                size="large"
              />
            </div>
            <div>
              <Text
                strong
                style={{ fontSize: '14px', marginBottom: '8px', display: 'block' }}
              >
                Body *
              </Text>
              <RichTextEditor
                value={emailBody}
                onChange={onEmailBodyChange}
                placeholder="Enter email body"
                rows={6}
              />
            </div>
          </Space>
        </Card>
      </Space>

      <div style={{ marginTop: '24px' }}>
        <Button
          type="primary"
          onClick={onSend}  
          loading={sendingNotes}
          disabled={sendingNotes || contactLoading}
          style={{
            fontSize: '14px',
            height: '36px',
            borderRadius: '6px',
            minWidth: '100px',
            background: contactLoading
              ? '#d9d9d9'
              : 'linear-gradient(135deg, #1890ff 0%, #40a9ff 100%)',
            border: 'none',
            boxShadow: contactLoading
              ? 'none'
              : '0 2px 8px rgba(24, 144, 255, 0.3)',
          }}
        >
          {contactLoading
            ? 'Loading...'
            : sendingNotes
            ? !isSendEmail || selectedEmailRecipients.length === 0
              ? 'Saving...'
              : 'Sending...'
            : !isSendEmail || selectedEmailRecipients.length === 0
            ? 'Save'
            : 'Send'}
        </Button>
        {!isSendEmail && (
          <div style={{ fontSize: '12px', color: 'red', marginTop: '8px' }}>
            * The email will not be sent because you have not enabled the email sending feature in settings.
          </div>
        )}
      </div>
    </>
  );
};

export default EmailComposeForm;

